<template>
  <VModal title="ورود به حساب کاربری" :show="show">
    <h6 class="text-sm">برای ثبت سفارش لطفا وارد اکانت خود شوید.</h6>

    <form @submit.prevent="showVerifyInput ? verifyPhone() : login()">
      <VInput
        type="text"
        placeholder="شماره موبایل"
        class="w-full mt-4"
        v-model="inputPhone.value"
        :disabled="showVerifyInput"
        :error="inputPhone.error"
        @keydown="inputPhone.error = ''"
        required
      />
      <span class="text-xs text-red-500" v-if="inputPhone.error">{{
        inputPhone.error
      }}</span>

      <VInput
        type="number"
        placeholder="کد تایید"
        class="w-full mt-4"
        v-model="verificationCode"
        :disabled="!showVerifyInput"
        required
        v-if="showVerifyInput"
      />

      <VButton
        class="w-full mt-4 shadow-lg bg-bgbuttontest text-white"
        type="submit"
        :loading="loading"
        >ورود</VButton
      >
    </form>
  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VButton from "@/components/General/VButton";

export default {
  name: "LoginModal",
  components: { VButton, VInput, VModal },
  props: ["show"],
  data() {
    return {
      loading: false,
      inputPhone: {
        value: "",
        error: "",
      },
      verificationCode: "",
      showVerifyInput: false,
      reLogin: false,
    };
  },
  methods: {
    login() {
      this.loading = true;
      this.inputPhone.value = this.inputPhone.value.replace(/[۰-۹]/g, (value) =>
        "۰۱۲۳۴۵۶۷۸۹".indexOf(value)
      );
      if (this.validatePhoneNumber()) {
        this.$store
          .dispatch("login", this.inputPhone.value)
          .then((resp) => {
            this.showVerifyInput = true;
            this.verificationCode = resp;
            this.$swal({
              icon: "success",
              title: "موفق",
              text: "کد تایید برای شما پیامک شد.",
              confirmButtonColor: "#fcd34d",
              confirmButtonText: "باشه",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    verifyPhone() {
      this.loading = true;
      let params = {
        phone: this.inputPhone.value,
        verificationCode: this.verificationCode,
      };
      this.$store
        .dispatch("verifyPhone", params)
        .then(() => {
          this.$modalLogin.value = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validatePhoneNumber() {
      let result = true;

      if (!this.inputPhone.value) {
        this.inputPhone.error = "لطفا شماره خود را وارد کنید";

        result = false;
      } else if (this.inputPhone.value.length !== 11) {
        this.inputPhone.error = "شماره همراه باید 11 رقم باشد";

        result = false;
      } else if (this.inputPhone.value.substr(0, 2) !== "09") {
        this.inputPhone.error = "شماره همراه باید با 09 شروع شود";

        result = false;
      }

      return result;
    },
  },
};
</script>

<style scoped></style>
